// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import OrderedListOutlinedSvg from "@ant-design/icons-svg/es/asn/OrderedListOutlined";
import AntdIcon from '../components/AntdIcon';

var OrderedListOutlined = function OrderedListOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: OrderedListOutlinedSvg
  }));
};

OrderedListOutlined.displayName = 'OrderedListOutlined';
export default React.forwardRef(OrderedListOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/OrderedListOutlined.js
// module id = 1533
// module chunks = 0